import { StoreApi, UseBoundStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { AnyObject } from '@sola/schema/dotcom/helpers.js';

/**
 * Helper utility for selecting multiple slices from a Zustand store.
 * @TODO There is room for improvement here,
 * ideally we would like the return type to leverage the keys being passed in.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useZustandSlices = <TState extends Record<string, any>>(
  useStoreFunc: UseBoundStore<StoreApi<AnyObject>>,
  ...keys: (keyof TState)[]
): TState => {
  return useStoreFunc(
    // @ts-expect-error @TODO: Type this!
    !keys.length
      ? (state: AnyObject) => {
          return state;
        }
      : // TODO: Are we ok with this conditional useShallow...?
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useShallow((state: AnyObject) => {
          // @ts-expect-error @TODO: Type this!
          return keys.reduce((valuesFromState, key: string) => {
            const returnValues = {
              ...valuesFromState,
            };

            // TODO: Just a simplistic solution to get nested values
            // Might need some recursion if we need to go deeper.
            if (key.includes('.')) {
              const [parentKey, childKey] = key.split('.');
              // @ts-expect-error @TODO: Type this!
              returnValues[childKey] = state[parentKey][childKey];
            } else {
              // @ts-expect-error @TODO: Type this!
              returnValues[key] = state[key];
            }

            return returnValues;
          }, {});
        }),
  );
};
